export function getHotelStayPricePerGuest({
  price,
  lowestPrice,
  isBundle,
  guests,
}: {
  price: number;
  lowestPrice: number;
  isBundle: boolean;
  guests: number;
}): number | null {
  if (!Number.isFinite(price)) return null;
  const safeGuests = Math.max(1, guests);
  if (isBundle) {
    if (!Number.isFinite(lowestPrice)) return null;
    return Math.abs(lowestPrice / safeGuests - price / safeGuests);
  }
  return price;
}

export function getLowestHotelPrice(
  hotels: readonly { price: number }[]
): number {
  let lowest = Infinity;
  for (const hotel of hotels) {
    if (Number.isFinite(hotel.price) && hotel.price < lowest) {
      lowest = hotel.price;
    }
  }
  return Number.isFinite(lowest) ? lowest : 0;
}

export function getHotelNightlyPrice({
  price,
  lowestPrice,
  isBundle,
  guests,
  startDate,
  endDate,
}: {
  price: number;
  lowestPrice: number;
  isBundle: boolean;
  guests: number;
  startDate: string;
  endDate: string;
}) {
  const nights = Math.round(
    (Date.parse(endDate.slice(0, 10)) - Date.parse(startDate.slice(0, 10))) /
      86400000
  );
  if (
    !Number.isFinite(price) ||
    (isBundle && !Number.isFinite(lowestPrice)) ||
    !Number.isFinite(nights) ||
    nights < 1 ||
    guests < 1 ||
    !Number.isFinite(guests)
  )
    return null;
  return (isBundle ? price - lowestPrice : price) / guests / nights;
}

export function isMapCoordinate(latitude: number, longitude: number) {
  return (
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    Math.abs(latitude) <= 90 &&
    Math.abs(longitude) <= 180
  );
}

const EARTH_RADIUS_MILES = 3958.8;

export function milesBetween(
  from: { latitude: number; longitude: number },
  to: { latitude: number; longitude: number }
): number {
  const toRad = (degrees: number) => (degrees * Math.PI) / 180;
  const dLat = toRad(to.latitude - from.latitude);
  const dLng = toRad(to.longitude - from.longitude);
  const lat1 = toRad(from.latitude);
  const lat2 = toRad(to.latitude);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return EARTH_RADIUS_MILES * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
